import script from "./UseCasesView.vue?vue&type=script&setup=true&lang=js"
export * from "./UseCasesView.vue?vue&type=script&setup=true&lang=js"

import "./UseCasesView.vue?vue&type=style&index=0&id=8d0a29de&lang=scss"

const __exports__ = script;

export default __exports__